import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { IChecklistTaskDto, IChecklistTaskRequestItem } from '@features/Checklist/model/types';
import { keysToCamel } from '@shared/helpers';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

import { checklistApiHandlers } from './api-handlers';

export const checklistApi = {
    getChecklistDataQuery: ({ positionGuid }: { positionGuid: string }) =>
        queryOptions({
            queryKey: ['checklist', 'data', positionGuid],
            queryFn: (meta) =>
                checklistApiHandlers.getChecklistData({ signal: meta.signal }, positionGuid),
            select: (data) => {
                const parsedData = keysToCamel<{
                    data: IChecklistTaskDto[];
                    context: { canModifyChecklist: boolean; canViewChecklistBtn: boolean };
                    status: IDataResponse['status'];
                    tariffPopupUrl: string;
                }>(data?.data);
                return parsedData;
            },
            refetchOnMount: false,
            placeholderData: keepPreviousData,
        }),
    updateChecklistDataQuery: ({
        positionGuid,
        data,
    }: {
        positionGuid: string;
        data: IChecklistTaskRequestItem[];
    }) => checklistApiHandlers.updateChecklistData({ positionGuid, data }),
    deleteChecklistDataQuery: ({ positionGuid }: { positionGuid: string }) =>
        checklistApiHandlers.deleteChecklist({ positionGuid }),
    switchChecklistDataQuery: ({
        positionGuid,
        checklistItemId,
    }: {
        positionGuid: string;
        checklistItemId: string;
    }) => checklistApiHandlers.switchChecklistItem({ positionGuid, checklistItemId }),
};
